import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";

export const dateOperators = new Set([
  FilterOperator.AFTER,
  FilterOperator.BEFORE,
  FilterOperator.IN_RANGE,
  FilterOperator.NOT_ON,
  FilterOperator.ON,
  FilterOperator.ON_OR_AFTER,
  FilterOperator.ON_OR_BEFORE,
]);

export const timeOperators = new Set([
  FilterOperator.AFTER,
  FilterOperator.BEFORE,
  FilterOperator.NOT_ON,
  FilterOperator.ON,
  FilterOperator.ON_OR_AFTER,
  FilterOperator.ON_OR_BEFORE,
]);

export const SET_FILTER_OPERATOR = FilterOperator.IN_ANY;
